import React from 'react';

const Leafdance = (props) => {
    let num = props.num;
    let innerDivs = [];
    for (let i = 0; i<=num; i++){
        innerDivs.push(<div key={i + "L"} className={`sideL-${i}`}></div>);
        innerDivs.push(<div key={i + "R"} className={`sideR-${i}`}></div>);
    }
    return (
        <div id="leafdance">
            {innerDivs}
        </div> 
    )
}

export default Leafdance;